// Presentation only. No plan/age rate lookup or live market rates are assumed.
export const garFields = [
  ['planName', 'Plan / policy reference', 'text'],
  ['ageAtAnnuity', 'Client age at annuity commencement', 'number'],
  ['illustrationDate', 'Fund illustration date', 'date'],
  ['annuityDate', 'Annuity commencement date', 'date'],
  ['garReference', 'GAR evidence / provider illustration reference', 'text'],
  ['marketSource', 'Open-market provider / sourcing reference', 'text'],
  ['quoteDate', 'Open-market quote date', 'date'],
  ['garConditions', 'GAR conditions: eligible age, life basis, guarantee period, payment timing, health terms and charges', 'text'],
  ['marketConditions', 'Open-market quote: age, life basis, guarantee period, payment timing, health terms and charges', 'text'],
  ['taxFreeCashPercent', 'Cash assumed from each fund (%) - confirm plan-specific treatment', 'number'],
  ['reductionInYieldPercent', 'New plan reduction in yield (%) for optional growth estimate', 'number'],
];
export const trancheFields = [
  ['name', 'Tranche / benefit name', 'text'],
  ['fundValue', 'Transferable fund before cash (£)', 'number'],
  ['guaranteedFundValue', 'Provider-confirmed guaranteed cash sum / fund before cash (£)', 'number'],
  ['garMode', 'GAR input basis', 'select'],
  ['garRatePercent', 'Plan-specific GAR (%) for this age and basis', 'number', 'gar', 'rate'],
  ['garAnnualIncome', 'Actual GAR annual income after the selected cash (£)', 'number', 'gar', 'income'],
  ['marketMode', 'Open-market input basis', 'select'],
  ['marketRatePercent', 'Adviser-sourced open-market rate (%)', 'number', 'market', 'rate'],
  ['marketAnnualIncome', 'Actual open-market annual income after cash (£)', 'number', 'market', 'income'],
  ['marketQuotePurchasePrice', 'Purchase price on the open-market quote (£)', 'number', 'market', 'income'],
  ['garEscalationPercent', 'GAR fixed annual escalation (%)', 'number'],
  ['marketEscalationPercent', 'Open-market fixed annual escalation (%)', 'number'],
  ['garSpousePercent', 'GAR spouse pension (% of initial income)', 'number'],
  ['marketSpousePercent', 'Open-market spouse pension (% of initial income)', 'number'],
];
export const blankTranche = () => ({ name: '', fundValue: '', guaranteedFundValue: '', garMode: 'rate', marketMode: 'rate', garEscalationPercent: '0', marketEscalationPercent: '0', garSpousePercent: '0', marketSpousePercent: '0' });
export const garExample = {
  planName: 'Workbook reference example - not a current quotation', ageAtAnnuity: 65,
  illustrationDate: '2026-10-14', annuityDate: '2030-08-31', quoteDate: '2026-10-14',
  garReference: 'Supplied workbook example; confirm actual plan and eligible age',
  marketSource: 'Historic workbook inputs only - obtain fresh open-market sourcing',
  garConditions: 'Illustrative age 65 only (age not specified in workbook). Confirm all GAR eligibility and payment terms.',
  marketConditions: 'Quotation terms are not documented in the workbook; like-for-like comparison is unconfirmed.',
  taxFreeCashPercent: 25, reductionInYieldPercent: 0, basisConfirmed: false,
  tranches: [
    { ...blankTranche(), name: 'Pre 97', fundValue: 104228.2, guaranteedFundValue: 104228.2, garRatePercent: 5, marketRatePercent: 6.49536, garEscalationPercent: 3, marketEscalationPercent: 0, garSpousePercent: 50, marketSpousePercent: 0 },
    { ...blankTranche(), name: 'Post 97', fundValue: 571.8, guaranteedFundValue: 571.8, garRatePercent: 3.5, marketRatePercent: 5.37924, garEscalationPercent: 5, marketEscalationPercent: 0, garSpousePercent: 50, marketSpousePercent: 0 },
  ],
};
